var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"video-modal__container"},[_c('button',{staticClass:"video-modal__close-btn",on:{"click":function($event){$event.preventDefault();_vm.closeModal()}}},[_vm._v("\n\t\tReturn\n\t")]),_vm._v(" "),_c('VideoJs',{attrs:{"videoServer":_vm.video.src,"autoplay":true,"cc":_vm.video.cc}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39b25434","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoModal/index.vue
// module id = null
// module chunks = 